import React from "react";
import classNames from "classnames";
import { useUiContext } from "@rotorstudios/fe-ui";
import { Typography, VehicleCard as VehicleCardTK } from "@tmca/toyota-kit";

import QAWrapperTK from "../../../modules/toyota-kit/QAWrapperTK";
import {
  QA_ALL_VEHICLES_BUTTON_EXPLORE,
  QA_ALL_VEHICLES_GRID_ITEM_CARD,
} from "../../../modules/Data/static";
import "./VehicleCard.scss";

export interface IVehicleCard {
  id: string;
  title: string;
  description: string;
  tags: string[];
  label: string;
  imageUrl: string;
  imageAlt: string;
}

interface CardProps {
  card: IVehicleCard;
  onButtonClick?: () => void;
}

const VehicleCard: React.FC<CardProps> = ({
  card: { id, title, label, description, imageUrl, imageAlt, tags },
  onButtonClick,
}) => {
  const { projectClass, breakpointActive } = useUiContext();

  const getClassName = () =>
    classNames(
      `${projectClass}_VehicleCard`,
      breakpointActive,
      id,
      ...tags.map((tag) => `${projectClass}_VehicleCard--${tag}`),
    );

  return (
    <div className={getClassName()} data-qa={QA_ALL_VEHICLES_GRID_ITEM_CARD}>
      <QAWrapperTK id={QA_ALL_VEHICLES_BUTTON_EXPLORE}>
        <VehicleCardTK
          vehicleName={title}
          vehicleImage={<img alt={imageAlt ?? title} src={imageUrl} />}
          cta1IsButton
          cta1UrlLabel="Explore"
          vehicleTagLabel={label}
          vehicleTagColour="#2468ff"
          vehicleCopy={<Typography variant="b1">{description}</Typography>}
          hasDivider
          ctaOnClick={onButtonClick}
        />
      </QAWrapperTK>
    </div>
  );
};

export default VehicleCard;
